import type { Features } from 'utils/account/types';

import type { WidgetDefinition, WidgetId } from './types';
import { ALL_WIDGET_IDS, WIDGET_REGISTRY } from './widgetRegistry';

export type WidgetAvailability = 'available' | 'unavailable' | 'pending';

export type FeatureAccess = {
  features: Features;
  loading: boolean;
  error?: unknown;
  /** The user's release toggles; without it, widgets requiring a toggle are unavailable. */
  hasReleaseToggle?: (releaseToggle: string) => boolean;
};

export function getWidgetAvailability(
  definition: Pick<WidgetDefinition, 'requiredFeatures' | 'requiredReleaseToggles'>,
  access: FeatureAccess
): WidgetAvailability {
  // Release toggles come with the user, so there is nothing to wait for
  const hasReleaseToggles = (definition.requiredReleaseToggles ?? []).every(
    toggle => access.hasReleaseToggle?.(toggle) ?? false
  );
  if (!hasReleaseToggles) {
    return 'unavailable';
  }
  if (definition.requiredFeatures.every(feature => access.features[feature])) {
    return 'available';
  }
  return access.loading || access.error ? 'pending' : 'unavailable';
}

export function getAvailableWidgetIds(access: FeatureAccess): WidgetId[] {
  return ALL_WIDGET_IDS.filter(
    id => getWidgetAvailability(WIDGET_REGISTRY[id], access) === 'available'
  );
}
